import { reduxForm } from 'redux-form';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';

class errorPage404Private extends Component {

  render() {
    return (
        <div className="hgt100">
          <div className="errorwrap">
            <div className="errorblock">
                <div className="errorbox">
                    <h3 className="title-404">4<i className="fa fa-frown-o" aria-hidden="true"></i>4</h3>
                    <h4>OOPS!</h4>
                    <p>The page you are looking for is not available.</p>
                </div>
            </div>
          </div>
          {/* <NavLink className="gobackbtn" exact to={this.props.loginUserInfo && this.props.loginUserInfo.users3.userRoles.roleName !== 'Client'? '/dashboard' : '/client-dashboard' }>GO BACK TO DASHBOARD</NavLink> */}
          <NavLink className="gobackbtn" exact to={this.props.loginUserInfo && this.props.loginUserInfo.users3.userRoles.roleName !== 'Client'? '/dashboard' : '/my-profile' }>GO BACK TO DASHBOARD</NavLink>
        </div>
    );
  }
}

errorPage404Private = reduxForm({
  form: 'errorPage404Form',
  enableReinitialize: true, // this is needed!!
})(errorPage404Private);

function mapStateToProps(state){
  return {
    loginUserInfo: state.login.loginUserInfo,
  };  
}

export default connect(mapStateToProps)(errorPage404Private);



// WEBPACK FOOTER //
// ./src/containers/errorPage404Private.js